<template>
  <div class="divider">
    <div class="divider-line"></div>
    <b-icon-star-fill font-scale="2"></b-icon-star-fill>
    <div class="divider-line"></div>
  </div>
</template>

<script>
import { BIconStarFill } from "bootstrap-vue";

export default {
  name: "Divider",
  components: {
    BIconStarFill,
  },
};
</script>

<style scoped>
.divider {
  margin: 1.25rem 0 1.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.divider-line {
  margin-left: 1rem;
  margin-right: 1rem;
  width: 100%;
  max-width: 7rem;
  height: 0.25rem;
  background-color: #fff;
}
</style>
